// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>34</span>&nbsp;&nbsp;Ascribe power to God, whose splendour is over Israel,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;whose power is above the clouds.<br> </p> </div></div>";
// Exports
module.exports = code;